var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"fof"},[_c('h1',[_vm._v("Error 404")]),_c('div',[_vm._v("Pagina niet gevonden")]),_c('br')])])}]

export { render, staticRenderFns }